var DEGREE = 180 / Math.PI;

var toDegree = function toDegree(radian) {
  return DEGREE * radian;
};

module.exports = toDegree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/to-degree.js
// module id = 69
// module chunks = 0 1 2